/**
 * Return a value from the Datalayer. If the value is the string "null" or "undefined", returns undefined instead.
 */
export function getSanitizedDataLayerValue(name: string): string | undefined {
  const dlValue = dataLayerHelper.get<string>(name);
  if (dlValue && dlValue !== "null" && dlValue !== "undefined") {
    return dlValue;
  }
  return undefined;
}
